import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "./Home";
import Navbar from "./navbar";
import Login from "./account/login";
import Admin from "./admin";
import ManageAnnouncements from "./admin/ManageAnnouncements";
import ManageBlacklistedEpisodes from "./admin/ManageBlacklistedEpisodes";
import ProtectedRoute from "./protectedRoute";
import CreateAnnouncement from "./admin/CreateAnnouncement";
import CreateUserPage from "./admin/UserPages/CreateUserPage";
import CustomPage from "./customPages";
import AboutUs from "./aboutUs/AboutUs";
import { Alert, AlertColor, Snackbar } from "@mui/material";
import ManageUserPages from "./admin/UserPages/ManageUserPages";
import Streaming from "./streaming";
import { createSignalRContext } from "react-signalr/signalr";
import PrivateRoute from "./privateRoute";
import Registration from "./Registration";
import RegistrationSuccess from "./RegistrationSuccess";
import Footer from "./components/Footer";
import Visitors from "./Visitors";
import CommunicationCenter from './CommunicationCenter';
import SendEmail from './admin/SendEmail';
import SendSms from './admin/SendSms';
import ManagePrayerRequests from './admin/ManagePrayerRequests';
import { ManageUsers } from './admin/ManageUsers';
import ForgotPassword from "./account/ForgotPassword";
import ResetPassword from "./account/ResetPassword";
import NotificationListener from "./components/NotificationListener";
import AnalyticsTracker from "./components/AnalyticsTracker";
import Unsubscribe from "./Unsubscribe";
import StaySubscribed from "./StaySubscribed";
import ListManagement from "./admin/ListManagement";
import UpcomingEvents from "./UpcomingEvents";
import EmailAnalytics from "./admin/EmailAnalytics";
import EmailCampaignDetail from "./admin/EmailCampaignDetail";
import Groups from "./groups/Groups";
import GroupDetail from "./groups/GroupDetail";
import GroupSetup from "./groups/GroupSetup";
import ManageGroups from "./admin/groups/ManageGroups";
import ManageGroup from "./admin/groups/ManageGroup";

const Emitter = require("tiny-emitter/instance");


function App() {
  const [open, setOpen] = React.useState<boolean>(false);
  const [notification, setNotification] = React.useState<string>();
  const [severity, setSeverity] = React.useState<AlertColor>();

  const token = "";

  Emitter.on("notify", (msg: string, color: AlertColor) => {
    setOpen(!open);
    setNotification(msg);
    setSeverity(color);
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <NotificationListener />
        <AnalyticsTracker />
        <Navbar />
        <main style={{ flex: 1, paddingTop: '80px' }}>
          <Routes>
            <Route path="/" index element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/registration-success" element={<RegistrationSuccess />} />
            <Route path="/visitors" element={<Visitors />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/Streaming" element={<Streaming />} />
            <Route path="/Admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/ManageUserPage" element={<ProtectedRoute roles={["Admin", "PageEditor"]}><ManageUserPages /></ProtectedRoute>} />
            <Route path="/admin/create-page" element={<ProtectedRoute roles={["Admin", "PageEditor"]}><CreateUserPage /></ProtectedRoute>} />
            <Route path="/CustomUserPage" element={<ProtectedRoute roles={["Admin", "PageEditor"]}><CreateUserPage /></ProtectedRoute>} />
            <Route path="/ManageAnnouncements" element={<ProtectedRoute><ManageAnnouncements /></ProtectedRoute>} />
            <Route path="/CommunicationCenter" element={<ProtectedRoute><CommunicationCenter /></ProtectedRoute>} />
            <Route path="/CommunicationCenter" element={<ProtectedRoute><CommunicationCenter /></ProtectedRoute>} />
            <Route path="/send-email" element={<ProtectedRoute><SendEmail /></ProtectedRoute>} />
            <Route path="/send-sms" element={<ProtectedRoute><SendSms /></ProtectedRoute>} />
            <Route path="/admin/prayer-requests" element={<ProtectedRoute><ManagePrayerRequests /></ProtectedRoute>} />
            <Route path="/admin/episodes" element={<ProtectedRoute><ManageBlacklistedEpisodes /></ProtectedRoute>} />
            <Route path="/admin/manage-users" element={<ProtectedRoute><ManageUsers /></ProtectedRoute>} />
            <Route path="/admin/list-management" element={<ProtectedRoute><ListManagement /></ProtectedRoute>} />
            <Route path="/admin/email-analytics" element={<ProtectedRoute><EmailAnalytics /></ProtectedRoute>} />
            <Route path="/admin/email-analytics/:campaignId" element={<ProtectedRoute><EmailCampaignDetail /></ProtectedRoute>} />
            <Route path="/unsubscribe/:guid" element={<Unsubscribe />} />
            <Route path="/stay-subscribed/:guid" element={<StaySubscribed />} />
            <Route path="/upcoming-events" element={<UpcomingEvents />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/groups/setup/:token" element={<GroupSetup />} />
            <Route path="/groups/:id" element={<GroupDetail />} />
            <Route path="/admin/groups" element={<ProtectedRoute roles={["Admin", "GroupAdmin"]}><ManageGroups /></ProtectedRoute>} />
            <Route path="/admin/groups/:id" element={<ProtectedRoute roles={["Admin", "GroupAdmin"]}><ManageGroup /></ProtectedRoute>} />
            <Route path=":id" element={<CustomPage />} />
          </Routes>
        </main>
        <Footer />
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {notification}
          </Alert>
        </Snackbar>
      </div>
    </React.Fragment>
  );
}

export default App;